/**
 * ATS keyword taxonomy (dictionary `category` field).
 * Keep scraper/core/keywords/dictionary.py VALID_CATEGORIES in sync.
 */

export const KEYWORD_CATEGORIES = Object.freeze([
  "job_title",
  "skill",
  "technology",
  "programming_language",
  "domain",
  "education",
  "certification",
  "language",
  "responsibility",
  "soft_skill",
]);

export const VALID_CATEGORIES = new Set(KEYWORD_CATEGORIES);

/** Human labels for UI (Resume keywords panel, etc.). */
export const KEYWORD_CATEGORY_LABELS = Object.freeze({
  job_title: "Job Titles",
  skill: "Skills",
  technology: "Technologies",
  programming_language: "Programming Languages",
  domain: "Domains",
  education: "Education",
  certification: "Certifications",
  language: "Languages",
  responsibility: "Responsibilities",
  soft_skill: "Soft Skills",
});

/**
 * Boost may weave these when evidence allows.
 * Everything else is a hard gap (do not invent).
 */
export const BOOSTABLE_CATEGORIES = new Set(["soft_skill", "responsibility", "domain"]);

/**
 * Skills-section chips / tool laundry (not franchise labels).
 */
export const SKILLS_CHIP_CATEGORIES = new Set(["technology", "programming_language", "skill"]);

/** Legacy category → new taxonomy (stored job/resume keywords + old dict rows). */
export const LEGACY_CATEGORY_MAP = Object.freeze({
  required: "skill",
  preferred: "responsibility",
  tool: "technology",
  technology: "technology",
  programming_language: "programming_language",
  responsibility: "responsibility",
  skill: "skill",
  domain: "domain",
  education: "education",
  soft_skill: "soft_skill",
  certification: "certification",
  language: "language",
  job_title: "job_title",
});

/**
 * @param {string} raw
 * @returns {string}
 */
export function normalizeKeywordCategory(raw) {
  const key = String(raw || "")
    .trim()
    .toLowerCase();
  if (!key) return "";
  if (VALID_CATEGORIES.has(key)) return key;
  return LEGACY_CATEGORY_MAP[key] || "";
}

/**
 * @param {string} category
 * @returns {string}
 */
export function keywordCategoryLabel(category) {
  const key = normalizeKeywordCategory(category) || String(category || "").trim().toLowerCase();
  return KEYWORD_CATEGORY_LABELS[key] || key || "Other";
}
